import { ThemeUICSSObject } from '@apia/theme';
/* IMPORT HERE */

const toolbar: ThemeUICSSObject = {
  /* PREPEND HERE */

  display: 'flex',
  gap: 2,
  position: 'fixed',
  right: '20px',
  top: '10px',

  '@media print': {
    display: 'none',
  },
};

export default toolbar;
